import type { FaireProductEntity } from "../../entity_types/product";

export const p_z8ws35rrwb: FaireProductEntity = {
  token: "p_z8ws35rrwb",
  type: "product",
  name: "12 Inch Sacred Heart Of Mary",
  brandToken: "b_6clm7lye",
  brandName: "Hi-Line Gift Ltd.",
  imageUrl: "https://cdn.faire.com/fastly/f496a9dc254540ffe94c156974b633969055272ccfa1dcefc630e8c74e893a4c.jpeg",
  galleryImageUrls: [],
  priceDollars: 26.5,
  description: "This stunning Sacred Heart Virgin Mary statue beautifully captures the Blessed Mother in a moment of profound love and devotion. With a heart glowing with divine light, this statue represents Mary’s unwavering love for humanity and her role as a compassionate intercessor. Perfect for homes, churches, or prayer spaces, this statue is a powerful reminder of Mary’s grace and compassion, offering peace, comfort, and spiritual strength to all who view it. Crafted with exquisite detail from high-quality polyresin, this statue radiates beauty and devotion.",
  tags: [],
  msrpDollars: 58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:15.124Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
